/* SaltyCells - Shopify forms bridge.
   The original static site posted its forms to Netlify Forms via fetch('/', {method:'POST', urlencoded}).
   This shim intercepts those calls and re-posts them to Shopify's native /contact endpoint
   (contact/pre-order forms -> store email + customer record; discount form -> customer tagged 'discount-capture'). */
(function () {
  var _fetch = window.fetch;
  window.fetch = function (url, opts) {
    try {
      if (url === '/' && opts && String(opts.method).toUpperCase() === 'POST' && typeof opts.body === 'string' && opts.body.indexOf('form-name=') > -1) {
        var p = new URLSearchParams(opts.body);
        var form = p.get('form-name') || 'contact';
        var out = new URLSearchParams();
        out.set('utf8', '✓');
        out.set('contact[email]', p.get('email') || '');
        if (form === 'discount') {
          out.set('form_type', 'customer');
          out.set('contact[tags]', 'discount-capture');
          out.set('contact[accepts_marketing]', 'true');
        } else {
          out.set('form_type', 'contact');
          if (p.get('name')) out.set('contact[name]', p.get('name'));
          if (p.get('phone')) out.set('contact[phone]', p.get('phone'));
          var lines = ['Form: ' + form];
          ['subject', 'battery', 'vehicle', 'intent'].forEach(function (k) {
            if (p.get(k)) { lines.push(k.charAt(0).toUpperCase() + k.slice(1) + ': ' + p.get(k)); }
          });
          if (p.get('message')) lines.push('', p.get('message'));
          out.set('contact[body]', lines.join('\n'));
        }
        return _fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: out.toString(), credentials: 'same-origin' })
          .then(function (r) { if (r.status >= 400) throw new Error('form ' + r.status); return r; });
      }
    } catch (e) { /* fall through to real fetch */ }
    return _fetch.apply(this, arguments);
  };
})();
